import axios from 'axios';
import { language, xTenantId } from '../../consts';
import { getToken } from '../../utils/auth';

const requestUrl = process.env.REACT_APP_BASE_AUTH_URL;

export interface RetrieveGameLaunchUrlPayload {
  gameExternalId: string;
  currencyCode: string;
  gameLobbyUrl?: string;
  gameType?: string;
  isMiniMode?: boolean;
}

export type JackPots = Record<string | 'jackpotking' | 'jackpotking_regal' | 'jackpotking_royal', string>;

export const retrieveGameLaunchUrl = async (
  userProfileId: string,
  gameProvider: string,
  payload: RetrieveGameLaunchUrlPayload
): Promise<{ url: string }> => {
  const token = getToken();
  const config = {
    headers: {
      authorization: token ? `Bearer ${token}` : null,
      'X-Tenant-Id': xTenantId,
    },
  };

  const result = await axios.post(
    `${requestUrl}/${gameProvider}/v1/user-profiles/${userProfileId}/launch`,
    { ...payload, languageCode: language },
    config
  );

  return result?.data;
};
